export default {"src":"/_next/static/media/cw.084cedb4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};